import { type ComponentProps } from 'react';
import { Controller } from 'react-hook-form';
import { get } from 'lodash-es';
import { useReferralFormContext } from '../ReferralFormContext';
import SingleSelectField from '../components/SingleSelectField';

/** controlled by react-hook-form context */
const ControlledSingleSelectField = ({
  dataId,
  helperText,
  label,
  name,
  options,
  ...inputProps
}: ComponentProps<typeof SingleSelectField> & {
  dataId: string;
  helperText?: string;
  label: string;
  name: string;
  required?: boolean;
}) => {
  const { control, errors } = useReferralFormContext();
  const errorMessage = get(errors, name)?.message;

  return (
    <Controller
      control={control}
      name={name}
      render={({ ref, value, onChange }) => {
        return (
          <SingleSelectField
            {...inputProps}
            dataId={dataId}
            errorMessage={errorMessage}
            helperText={helperText}
            label={label}
            name={name}
            options={options}
            onChange={onChange}
            value={value}
            defaultValue={options[0]}
          />
        );
      }}
    />
  );
};
export default ControlledSingleSelectField;
